<template>
  <div class="employment-page">
    <!-- Banner Section -->
    <section class="hero" v-if="banners && banners.length">
      <el-carousel :interval="5000" arrow="hover" height="360px" indicator-position="outside">
        <el-carousel-item v-for="(b,i) in banners" :key="i">
          <div :style="getBannerStyle(b)" class="carousel-slide" @click="openAd(b)">
            <div class="overlay">
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </section>

    <div class="page-content">
      <!-- Recommended Enterprises -->
      <section class="section-block recommended-section">
        <div class="hr-header">
          <div class="hr-title-row">
            <div class="hr-title-main">
              <img src="@/assets/image/i_tt.png" alt="" class="hr-icon">
              <span>推荐企业</span>
            </div>
          </div>
          <div class="hr-subtitle">万名核心校友，为您内推不少知名互联网名企，直通名企 Offer</div>
          <div class="refresh-btn" v-if="recommendedEnterprises && recommendedEnterprises.length > 0" @click="handleRefreshRecommend">
            <i class="el-icon-refresh"></i> 换一换
          </div>
        </div>
        
        <div class="enterprise-grid">
          <div class="enterprise-card" v-for="(item, index) in recommendedEnterprises" :key="index">
            <div v-if="item.isHot" class="hot-badge">
              <span>HOT</span>
            </div>
            <div class="card-header">
              <div class="company-logo">
                <img v-if="item.enterpriseLogo" :src="item.enterpriseLogo" :alt="item.enterpriseName">
                <i v-else class="el-icon-office-building"></i>
              </div>
              <div class="company-info">
                <h3 class="company-name">{{ item.enterpriseName }}</h3>
                <div class="company-tags">
                  <span class="tag" v-if="item.enterpriseNature">{{ formatNature(item.enterpriseNature) }}</span>
                  <span class="tag" v-if="item.city">{{ item.city }}</span>
                </div>
              </div>
            </div>
            <div class="card-desc" :title="item.introduction">
              简介：{{ item.introduction | truncate(55) }}
              <span class="view-detail-btn" @click.stop="goToDetail(item)">[查看详情]</span>
            </div>
          </div>
        </div>
      </section>

      <!-- Employment Guide -->
      <section class="section-block guide-section">
        <div class="hr-header">
          <div class="hr-title-row">
            <div class="hr-title-main">
              <img src="@/assets/new_picture/i_tt_2.png" alt="" class="hr-icon">
              <span style="color: #fff;">就业指南</span>
            </div>
          </div>
          <div class="hr-subtitle" style="color: rgba(255,255,255,0.8);">只为核心推荐 为您的英才计划保驾护航 没有最好 只有更好</div>
        </div>
        
        <div class="guide-content">
          <div class="guide-arrow left" @click="prevGuide">
            <i class="el-icon-arrow-left"></i>
          </div>
          
          <div class="guide-grid">
            <div class="guide-item" v-for="(item, index) in visibleGuides" :key="item.id || index">
              <div class="guide-card-inner">
                <div class="guide-ribbon">
                  <span>{{ item.title }}</span>
                  <div class="ribbon-tail"></div>
                </div>
                <div class="guide-desc">
                  {{ item.content }}
                </div>
                <div class="guide-footer">
                  <span class="read-more" @click="goToGuideDetail(item)">【查看详情】</span>
                </div>
              </div>
            </div>
          </div>

          <div class="guide-arrow right" @click="nextGuide">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </section>

      <!-- Cooperative Enterprises -->
      <section class="section-block coop-section">
        <div class="hr-header">
          <div class="hr-title-row">
            <div class="hr-title-main">
              <img src="@/assets/image/i_tt.png" alt="" class="hr-icon">
              <span>合作企业</span>
            </div>
          </div>
          <div class="hr-subtitle">万名核心校友，为您内推不少知名互联网名企，直通名企 Offer</div>
        </div>
        
        <div class="coop-grid-wrapper">
          <div class="coop-scroll-container">
            <div 
              class="coop-scroll-row" 
              v-for="(row, rowIndex) in coopRows" 
              :key="'row-' + rowIndex"
            >
              <div class="coop-scroll-track">
                <!-- Original set -->
                <div class="coop-item-group">
                  <div class="coop-item" v-for="(item, index) in row" :key="'orig-' + index" @click="goToDetail(item)">
                     <img v-if="item.enterpriseLogo" :src="item.enterpriseLogo" :alt="item.enterpriseName" class="coop-logo" style="width:100%;height:100%;object-fit:contain;">
                     <span v-else>{{ item.enterpriseName }}</span>
                  </div>
                </div>
                <!-- Duplicate set for seamless scrolling -->
                <div class="coop-item-group">
                  <div class="coop-item" v-for="(item, index) in row" :key="'dup-' + index" @click="goToDetail(item)">
                     <img v-if="item.enterpriseLogo" :src="item.enterpriseLogo" :alt="item.enterpriseName" class="coop-logo" style="width:100%;height:100%;object-fit:contain;">
                     <span v-else>{{ item.enterpriseName }}</span>
                  </div>
                </div>
                <!-- Second Duplicate set for extra safety -->
                <div class="coop-item-group">
                  <div class="coop-item" v-for="(item, index) in row" :key="'dup2-' + index" @click="goToDetail(item)">
                     <img v-if="item.enterpriseLogo" :src="item.enterpriseLogo" :alt="item.enterpriseName" class="coop-logo" style="width:100%;height:100%;object-fit:contain;">
                     <span v-else>{{ item.enterpriseName }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Student Style -->
      <section class="section-block student-section">
        <div class="hr-header">
          <div class="hr-title-row">
            <div class="hr-title-main">
              <img src="@/assets/image/i_tt.png" alt="" class="hr-icon">
              <span>学员风采</span>
            </div>
          </div>
          <div class="hr-subtitle">万名核心校友，为您内推不少知名互联网名企，直通名企 Offer</div>
        </div>
        
        <div class="student-section-body">
          <div class="nav-btn prev" @click="prevStudent"><i class="el-icon-arrow-left"></i></div>
          
          <div class="student-card">
            <div class="student-info">
              <div class="student-quote">
                <h3>{{ currentStudent.name }}</h3>
                <div class="student-role-wrapper">
                  <span class="student-role">{{ currentStudent.role }}</span>
                </div>
                <div class="quote-text" @click="goStudentDetail(currentStudent)">
                  简介: {{ currentStudent.quote | truncateQuote }}
                  <span v-if="currentStudent.quote && currentStudent.quote.length > 80" class="quote-more">详情</span>
                </div>
              </div>
              
              <div class="student-photo-wrapper">
                <div class="student-photo">
                  <img :src="currentStudent.avatar || require('@/assets/new_picture/pic01.png')" alt="Student">
                </div>
              </div>
            </div>
          </div>
          
          <div class="nav-btn next" @click="nextStudent"><i class="el-icon-arrow-right"></i></div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { getAllEnterprises, getRecommendedEnterprises, getStudentShowcaseList } from '@/api/enterpriseApi'
import { addAdvertisementView, getAdvertisementList, getHomepageRecommendContents } from '@/api/courseApi'

export default {
  name: 'EmploymentPage',
  data() {
    return {
      banners: [],
      recommendedEnterprises: [],
      cooperativeEnterprises: [],
      employmentGuides: [],
      students: [],
      currentStudentIndex: 0,
      guideStartIndex: 0,
      guideVisibleCount: 4,
      guideTimer: null
    }
  },
  computed: {
    currentStudent() {
      return this.students[this.currentStudentIndex] || {}
    },
    coopRows() {
      const rows = [[], [], []];
      if (!this.cooperativeEnterprises || this.cooperativeEnterprises.length === 0) return rows;
      
      this.cooperativeEnterprises.forEach((item, index) => {
        rows[index % 3].push(item);
      });
      
      // Make all rows equal length to ensure consistent width and speed
      // Ensure minimum length so it covers wide screens
      const minItems = 8;
      const maxLength = Math.max(minItems, ...rows.map(r => r.length));
      rows.forEach(row => {
        let i = 0;
        const originalLength = row.length;
        if (originalLength === 0) return;
        while (row.length < maxLength) {
          row.push(row[i % originalLength]);
          i++;
        }
      });
      
      return rows;
    },
    visibleGuides() {
      const list = this.employmentGuides
      if (!list.length) return []
      const total = list.length
      const count = Math.min(this.guideVisibleCount, total)
      const start = this.guideStartIndex % total
      const result = []
      for (let i = 0; i < count; i++) {
        result.push(list[(start + i) % total])
      }
      return result
    }
  },
  mounted() {
    this.fetchRecommendedEnterprises()
    this.fetchCooperativeEnterprises()
    this.fetchHomepageAdvertisements()
    this.fetchEmploymentGuides()
    this.fetchStudentShowcase()
  },
  beforeDestroy() {
    this.stopGuideTimer()
  },
  filters: {
    truncate(value, limit) {
      if (!value) return ''
      value = value.toString()
      if (value.length > limit) {
        return value.substring(0, limit) + '...'
      }
      return value
    },
    truncateQuote(val) {
      if (!val) return ''
      return val.length > 80 ? val.substring(0, 80) + '...' : val
    }
  },
  methods: {
    formatNature(nature) {
      const map = {
        'state_owned': '国企',
        'private': '私企',
        'foreign': '外企',
        'joint_venture': '合资'
      }
      return map[nature] || nature
    },
    async fetchEmploymentGuides() {
      try {
        const res = await getHomepageRecommendContents({ contentCategory: 'employment_guide' })
        if (res && res.code === 200 && Array.isArray(res.data)) {
          this.employmentGuides = res.data.map(item => ({
            id: item.id,
            title: item.contentTitle,
            content: item.contentText ? item.contentText.replace(/<[^>]+>/g, '').slice(0, 100) + '...' : '',
            raw: item
          }))
          this.startGuideTimer()
        }
      } catch (err) {
        console.error('获取就业指南失败', err)
        this.employmentGuides = []
      }
    },
    async fetchStudentShowcase() {
      try {
        const res = await getStudentShowcaseList({
          pageNum: 1,
          pageSize: 10
        })
        if (res.code === 200 && res.data && res.data.list) {
          this.students = res.data.list.map(item => ({
            id: item.id,
            name: item.studentName,
            role: '优秀学员', // Default role if not provided
            quote: item.introduction || '在蜗牛学院的学习让我受益匪浅...',
            avatar: (item.photos && item.photos.length > 0) ? item.photos[0] : 'https://placeholder.com/50',
            photos: item.photos
          }))
        }
      } catch (e) {
        console.error('Failed to fetch student showcase:', e)
      }
    },
    getBannerStyle(b) {
      const bg = b && b.bg ? String(b.bg) : ''
      const image = b && b.image ? String(b.image) : ''
      if (image) {
        return {
          backgroundImage: `url(${image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }
      }
      return { background: bg }
    },
    openAd(banner) {
      const b = banner && typeof banner === 'object' ? banner : { link: banner }
      const url = String(b && b.link ? b.link : '').trim()
      if (!url) return
      const id = b && b.id
      if (id != null && id !== '') {
        addAdvertisementView(id).catch(() => {})
      }
      window.open(url, '_blank', 'noopener')
    },
    async fetchHomepageAdvertisements() {
      try {
        const res = await getAdvertisementList({displayPosition: 'employment_list'})

        const list = Array.isArray(res && res.data) ? res.data : []
        const enabled = list.filter(item => Number(item && item.enableStatus) === 1 && Number(item && item.adStatus) === 1)

        // Process Carousel Ads
        const carouselAds = enabled.filter(item => String(item && item.adType) === 'carousel')
        this.banners = carouselAds.map(item => ({
          id: item && item.id,
          image: item && item.adImage,
          link: item && item.adLink,
          title: item && item.adTitle,
          raw: item
        }))
      } catch (err) {
        this.banners = []
        console.error('获取广告失败', err)
      }
    },
    async fetchRecommendedEnterprises() {
      try {
        const res = await getRecommendedEnterprises()
        if (res.code === 200) {
          const list = res.data || []
          this.recommendedEnterprises = list.map((item, index) => ({
            ...item,
            // Mock isHot for demo if not present, e.g., first 2 items
            isHot: item.isHot !== undefined ? item.isHot : (index < 2),
            // Extract city from regionDisplay if city is missing
            city: item.city || (item.regionDisplay ? item.regionDisplay.split(' ')[0] : '未知'),
            // Ensure nature exists or mock it
            enterpriseNature: item.enterpriseNature || (index % 2 === 0 ? 'private' : 'state_owned')
          }))
        }
      } catch (error) {
        console.error('Failed to fetch recommended enterprises:', error)
      }
    },
    async fetchCooperativeEnterprises() {
      try {
        const res = await getAllEnterprises()
        if (res.code === 200) {
          this.cooperativeEnterprises = res.data || []
        }
      } catch (error) {
        console.error('Failed to fetch cooperative enterprises:', error)
      }
    },
    handleRefreshRecommend() {
      this.fetchRecommendedEnterprises()
    },
    goToDetail(item) {
      this.$router.push({
        name: 'enterpriseDetail',
        params: {
          id: item.id || 0,
          enterpriseData: item
        }
      })
    },
    goToGuideDetail(item) {
      this.$router.push({
        name: 'employmentGuideDetail',
        params: {
          id: item.id || 0,
          guideData: {
            id: item.id,
            title: item.title,
            date: item.raw && item.raw.createTime ? item.raw.createTime.slice(0, 10) : '',
            desc: item.raw ? item.raw.contentText : ''
          }
        }
      })
    },
    prevStudent() {
      this.currentStudentIndex = (this.currentStudentIndex - 1 + this.students.length) % this.students.length
    },
    nextStudent() {
      this.currentStudentIndex = (this.currentStudentIndex + 1) % this.students.length
    },
    goStudentDetail(student) {
      if (!student || !student.id) return
      this.$router.push({ name: 'studentDetail', params: { id: student.id } })
    },
    selectStudent(index) {
      if (index >= 0 && index < this.students.length) {
        this.currentStudentIndex = index
      }
    },
    prevGuide() {
      const total = this.employmentGuides.length
      if (!total) return
      this.guideStartIndex = (this.guideStartIndex - this.guideVisibleCount + total) % total
      this.resetGuideTimer()
    },
    nextGuide() {
      const total = this.employmentGuides.length
      if (!total) return
      this.guideStartIndex = (this.guideStartIndex + this.guideVisibleCount) % total
      this.resetGuideTimer()
    },
    startGuideTimer() {
      this.stopGuideTimer()
      if (this.employmentGuides.length <= this.guideVisibleCount) return
      this.guideTimer = setInterval(() => {
        this.nextGuide()
      }, 5000)
    },
    stopGuideTimer() {
      if (this.guideTimer) {
        clearInterval(this.guideTimer)
        this.guideTimer = null
      }
    },
    resetGuideTimer() {
      this.stopGuideTimer()
      this.startGuideTimer()
    }
  }
}
</script>

<style scoped lang="scss">
.employment-page {
  background-color: #fff;
  min-height: 100vh;
}

.hero {
  background: #fff;
}

.carousel-slide {
  height: 360px;
  background: linear-gradient(90deg, #4f46e5, #7c3aed);
  position: relative;
  cursor: pointer;
}

.overlay {
  position: absolute;
  left: 8%;
  top: 50%;
  transform: translateY(-50%);
  color: #fff;
}

.page-content {
  width: 100%;
  padding: 0;
  overflow-x: hidden;
}

.section-block {
  padding: 60px 0;
  margin-bottom: 0;
}

/* Centering wrappers for standard sections */
.recommended-section .hr-header,
.recommended-section .enterprise-grid,
.coop-section .hr-header,
.coop-section .coop-grid-wrapper,
.student-section .hr-header,
.student-section .student-section-body {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 20px;
  padding-right: 20px;
}

.hr-header {
  position: relative;
  text-align: center;
  margin-bottom: 30px;
  
  .hr-title-row {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
  }
  
  .hr-title-main {
    display: flex;
    align-items: center;
    gap: 10px;
    
    .hr-icon {
      width: 32px;
      height: 32px;
      object-fit: contain;
    }
    
    span {
      font-size: 28px;
      font-weight: 700;
      color: #333;
    }
  }
  
  .hr-subtitle {
    font-size: 14px;
    color: #666;
    letter-spacing: 1px;
  }

  .refresh-btn {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    color: #606266;
    font-size: 14px;
    display: flex;
    align-items: center;
    transition: color 0.3s;
    
    &:hover {
      color: #3E2CCD;
    }
    
    i {
      margin-right: 4px;
    }
  }
}

/* Recommended Enterprises */
.enterprise-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.enterprise-card {
  position: relative;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 20px;
  transition: all 0.3s;
  cursor: pointer;
  overflow: hidden;
  
  &:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
    transform: translateY(-5px);
  }

  .hot-badge {
    position: absolute;
    top: 0;
    right: 0;
    width: 50px;
    height: 50px;
    z-index: 10;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 50px 50px 0;
      border-color: transparent #f56c6c transparent transparent;
    }
    
    span {
      position: absolute;
      top: 10px;
      right: 4px;
      transform: rotate(45deg);
      color: #fff;
      font-size: 12px;
      font-weight: bold;
      line-height: 1;
      z-index: 1;
    }
  }
  
  .card-header {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    
    .company-logo {
      width: 60px;
      height: 60px;
      background: #f5f7fa;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 15px;
      font-size: 24px;
      color: #909399;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    
    .company-info {
      flex: 1;
      .company-name {
        font-size: 16px;
        color: #303133;
        font-weight: 600;
        margin-bottom: 8px;
      }
      
      .company-tags {
        display: flex;
        gap: 8px;
        
        .tag {
          background: #f4f4f5;
          color: #909399;
          font-size: 12px;
          padding: 2px 8px;
          border-radius: 4px;
        }
      }
    }
  }
  
  .card-desc {
    font-size: 13px;
    color: #606266;
    line-height: 1.6;
    text-align: justify;
    
    .view-detail-btn {
      color: #f56c6c;
      cursor: pointer;
      margin-left: 5px;
      font-size: 12px;
      
      &:hover {
        opacity: 0.8;
      }
    }
  }
}

/* Employment Guide */
.guide-section {
  background: url('~@/assets/new_picture/jy_bg01.png') no-repeat center center;
  background-size: cover;
  padding: 80px 0;
  
  .hr-header {
    max-width: 1200px;
    margin: 0 auto 40px;
  }
}

.guide-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 0 20px;
}

.guide-arrow {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 20px;
  flex-shrink: 0;
  
  &.left {
    background: #7B68EE; /* Purple */
    color: #fff;
    box-shadow: 0 4px 10px rgba(123, 104, 238, 0.4);
    
    &:hover {
      background: #6a5acd;
    }
  }
  
  &.right {
    background: #fff;
    color: #333;
    box-shadow: 0 4px 10px rgba(0,0,0,0.1);
    
    &:hover {
      background: #f0f0f0;
    }
  }
}

.guide-grid {
  flex: 1;
  display: flex;
  gap: 20px;
  overflow: hidden;
}

.guide-item {
  width: 240px;
  min-width: 240px;
  flex-shrink: 0;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 20px rgba(0,0,0,0.1);
  transition: transform 0.3s;
  min-height: 320px;
  
  &:hover {
    transform: translateY(-5px);
  }
}

.guide-card-inner {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.guide-ribbon {
  background: #5D9CEC; /* Base color */
  background: linear-gradient(90deg, #4facfe 0%, #00f2fe 100%); /* Nice teal gradient */
  /* Using a solid color that matches the screenshot better - dark teal */
  background: #4A89DC; 
  /* Specific colors for each card? Let's use a generic teal-blue */
  background-color: #559CAC;
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0 40px 0 20px;
  color: #fff;
  font-weight: bold;
  font-size: 16px;
  position: relative;
  clip-path: polygon(0 0, 100% 0, 95% 50%, 100% 100%, 0 100%);
  
  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

/* Adjust colors for variety if needed, or stick to one */
.guide-item:nth-child(1) .guide-ribbon { background: #5D9CEC; }
.guide-item:nth-child(2) .guide-ribbon { background: #4FC1E9; }
.guide-item:nth-child(3) .guide-ribbon { background: #48CFAD; }
.guide-item:nth-child(4) .guide-ribbon { background: #37BC9B; }

.guide-desc {
  padding: 25px 20px;
  font-size: 13px;
  color: #666;
  line-height: 1.8;
  flex: 1;
  text-align: justify;
}

.guide-footer {
  padding: 0 20px 25px;
  text-align: right;
  
  .read-more {
    color: #ff4d4f;
    font-size: 12px;
    font-weight: bold;
    cursor: pointer;
    
    &:hover {
      text-decoration: underline;
    }
  }
}

/* Student Style */
.student-section {
  margin-bottom: 60px;
}

.student-showcase {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0,0,0,0.05);
}

.student-section-body {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
  margin-bottom: 60px;
  margin-top: 50px;
}

.nav-btn {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 20px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  transition: all 0.3s;
  flex-shrink: 0;
  
  &.prev {
    background: #5D43F1;
    color: #fff;
    border: none;
    
    &:hover {
      background: #4b36c2;
    }
  }
  
  &.next {
    background: #fff;
    color: #999;
    border: 1px solid #ebeef5;
    
    &:hover {
      color: #333;
      border-color: #dcdfe6;
    }
  }
}

.student-card {
    flex: 1;
    padding: 30px 40px;
    background: linear-gradient(135deg, #1890FF 0%, #0050B3 100%); /* Blue gradient background */
    background-color: #1890FF;
    border-radius: 12px; /* Smaller rounded corners */
    box-shadow: 0 10px 20px rgba(24, 144, 255, 0.3);
    position: relative;
    overflow: hidden;
    
    /* Background decoration lines could be added here if needed */
    
    .student-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      z-index: 2;
    }
    
    .student-quote {
      flex: 1;
      padding-right: 30px;
      color: #fff;
      
      h3 {
        font-size: 24px;
        color: #fff;
        margin-bottom: 10px;
        font-weight: 600;
        letter-spacing: 1px;
      }
      
      .student-role-wrapper {
        margin-bottom: 15px;
      }
      
      .student-role {
        display: inline-block;
        background: #fff;
        color: #1890FF; /* Blue text */
        padding: 4px 12px;
        border-radius: 10px;
        font-size: 12px;
        font-weight: 500;
        box-shadow: 0 2px 6px rgba(0,0,0,0.1);
      }
      
      .quote-text {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.9);
        line-height: 1.6;
        font-weight: 400;
        text-align: justify;
        cursor: pointer;

        .quote-more {
          color: #7cb8ff;
          margin-left: 4px;
          font-size: 13px;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
    
    .student-photo-wrapper {
      width: 160px;
      height: 190px;
      background: #fff;
      border-radius: 10px;
      padding: 10px;
      box-shadow: 0 5px 15px rgba(0,0,0,0.15);
      display: flex;
      align-items: center;
      justify-content: center;
      transform: rotate(0deg); /* Reset rotation if any */
    }
  
    .student-photo {
      width: 100%;
      height: 100%;
      overflow: hidden;
      border-radius: 6px;
      
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: top center;
      }
    }
  }
  
  @media (max-width: 992px) {
    .student-section-body {
      flex-direction: column;
      gap: 20px;
    }
    
    .nav-btn {
      display: none;
    }
  
    .student-card {
      padding: 20px;
      
      .student-info {
        flex-direction: column-reverse;
        gap: 20px;
      }
      
      .student-quote {
        padding-right: 0;
        text-align: center;
        
        h3 {
          font-size: 20px;
        }
      }
      
      .student-photo-wrapper {
        width: 130px;
        height: 160px;
        margin: 0 auto;
      }
    }
  }

.guide-card {
  background: #fff;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
  
  .guide-header {
    background: #3E2CCD;
    color: #fff;
    padding: 15px;
    text-align: center;
    h3 {
      margin: 0;
      font-size: 16px;
    }
  }
  
  .guide-body {
    padding: 20px;
    p {
      font-size: 14px;
      color: #606266;
      line-height: 1.6;
      height: 100px;
      overflow: hidden;
    }
    .read-more {
      color: #f56c6c;
      padding: 0;
    }
  }
}

/* Cooperative Enterprises */
.coop-grid-wrapper {
  position: relative;
  overflow: hidden;
  padding: 20px 0;
  
  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 150px;
    z-index: 2;
    pointer-events: none;
  }
  
  &::before {
    left: 0;
    background: linear-gradient(to right, #fff 10%, rgba(255,255,255,0));
  }
  
  &::after {
    right: 0;
    background: linear-gradient(to left, #fff 10%, rgba(255,255,255,0));
  }
}

.coop-scroll-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.coop-scroll-row {
  display: flex;
  overflow: hidden;
  width: 100%;
}

.coop-scroll-track {
  display: flex;
  width: max-content;
  padding: 10px 0;
}

.coop-scroll-row:nth-child(1) .coop-scroll-track {
  animation: scroll-left 45s linear infinite;
}

.coop-scroll-row:nth-child(2) .coop-scroll-track {
  animation: scroll-right 35s linear infinite;
  animation-delay: -15s;
}

.coop-scroll-row:nth-child(3) .coop-scroll-track {
  animation: scroll-left 50s linear infinite;
  animation-delay: -25s;
}

.coop-item-group {
  display: flex;
  gap: 20px;
  padding-right: 20px; /* Same as gap to make seamless transition to next group */
}

.coop-scroll-row:hover .coop-scroll-track {
  animation-play-state: paused;
}

@keyframes scroll-left {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-33.333333%);
  }
}

@keyframes scroll-right {
  0% {
    transform: translateX(-33.333333%);
  }
  100% {
    transform: translateX(0);
  }
}

.coop-item {
  background: #fff;
  border: 1px solid #fff;
  width: 180px;
  height: 80px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.3s;
  box-shadow: 0 6px 16px rgba(0,0,0,0.08);
  cursor: pointer;
  
  &:hover {
    box-shadow: 0 10px 24px rgba(0,0,0,0.12);
    transform: translateY(-2px);
  }
  
  .coop-logo {
    max-width: 70%;
    max-height: 70%;
    transition: transform 0.3s;
  }
  
  &:hover .coop-logo {
    transform: scale(1.1);
  }
}

</style>